import status from "../../constants/actionStatus";

const getCourseListReducer = (
    state = {
        course: [],
        isLoading: false,
        error: null,
    },
    action = {}
) => {
    switch (action.type) {
    case "COURSE_LIST_REQUEST":
        return {
            ...state,
            status: status.PENDING,
            course: [],
            isLoading: true,
            error: null,
        };
    case "COURSE_LIST_SUCCESS":
        return {
            ...state,
            data: action.skipCourse === 0 ? action.payload.data : [...(state.data || []), ...action.payload.data],
            status: status.SUCCESS,
            course: action.payload,
            totalCount: action.payload.totalCount,
            isLoading: false,
        };

    case "COURSE_LIST_FAILURE":
        return {
            ...state,
            status: status.ERROR,
            course: [],
            isLoading: false,
            error: action.payload,
        };
    default:
        return state;
    }
};

export default getCourseListReducer;
